import request from '@/utils/request'

export function getUserInfo() {
  return request({
    url: '/user/info',
    method: 'get'
  })
}

export function getOnlineStatus(userId) {
  return request({
    url: '/user/onlineStatus',
    method: 'get',
    params: { userId }
  })
}

export function getSoundEnabled() {
  return request({
    url: '/user/soundEnabled',
    method: 'get'
  })
}

export function updateSoundEnabled(soundEnabled) {
  return request({
    url: '/user/soundEnabled',
    method: 'post',
    data: { soundEnabled }
  })
}

